import { MarketId } from '@velocity-exchange/common';
import { MarketType } from '@velocity-exchange/sdk';
import useGetTickSizeForMarket, {
	getTickSizeDecimalPlaces,
} from 'src/hooks/useGetTickSizeForMarket';
import useMarkPrice from 'src/hooks/useMarkPrice';
import TextButton from 'src/components/primitives/TextButton/TextButton';

interface Props {
	marketIndex: number;
	handleChange: (value: string) => void;
	marketType: MarketType;
}

export default function PriceInputMidButton({
	marketIndex,
	handleChange,
	marketType,
}: Props) {
	const marketId = new MarketId(marketIndex, marketType);
	const currentMarkPrice = useMarkPrice(marketId);
	const getTickSizeForMarket = useGetTickSizeForMarket();
	const tickSize = getTickSizeForMarket(marketId);
	const decimalPlaces = getTickSizeDecimalPlaces(tickSize);

	return (
		<TextButton
			size="md"
			variant="tertiary"
			onClick={() => handleChange(currentMarkPrice.toFixed(decimalPlaces))}
		>
			Mid
		</TextButton>
	);
}
